import { render, staticRenderFns } from "./DashboardUpcoming.vue?vue&type=template&id=3da62665&scoped=true"
import script from "./DashboardUpcoming.vue?vue&type=script&lang=js"
export * from "./DashboardUpcoming.vue?vue&type=script&lang=js"
import style0 from "./DashboardUpcoming.vue?vue&type=style&index=0&id=3da62665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da62665",
  null
  
)

export default component.exports